import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class ReedSolomonException extends Exception {
}
ReedSolomonException.kind = 'ReedSolomonException';
export default ReedSolomonException;
